// extracted by mini-css-extract-plugin
export var compact = "_no-2";
export var phoneFrame = "_no-0";
export var phoneScreen = "_no-1";